<div class="identificacao-colunas">
  <form class="identificacao" novalidate>
    <h2 class="identificacao-titulo">Identificação do solicitante</h2>

    @if (store.anonimo()) {
      <a class="identificacao-selo" routerLink="/cadastro">
        <i-lucide name="id-card" size="16" aria-hidden="true"></i-lucide>
        Cadastro no Portal para solicitação identificada
        <i-lucide class="identificacao-selo-seta" name="arrow-right" size="16" aria-hidden="true"></i-lucide>
      </a>
    }

    @if (store.sessaoIniciada()) {
      <p class="identificacao-nota">
        <i-lucide name="circle-check" size="16" aria-hidden="true"></i-lucide>
        Dados carregados do seu cadastro no portal. Revise e ajuste, se necessário.
      </p>
    }

    @if (errosServidor().length) {
      <ul class="identificacao-aviso identificacao-aviso-lista" role="alert">
        @for (erro of errosServidor(); track erro) {
          <li>
            <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
            {{ erro }}
          </li>
        }
      </ul>
    }

    @if (mostrarPendencias() && !store.identificacaoValida()) {
      <p class="identificacao-aviso" role="alert">
        <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
        Preencha os campos obrigatórios destacados para avançar.
      </p>
    }

    <div class="identificacao-campo">
      <label class="identificacao-rotulo" for="identificacao-nome">
        Nome completo <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
      </label>
      <input
        id="identificacao-nome"
        class="identificacao-input"
        type="text"
        autocomplete="name"
        placeholder="Digite seu nome completo"
        [formField]="store.identificacaoForm.nomeCompleto"
      />
      @if (store.identificacaoForm.nomeCompleto().touched() && store.identificacaoForm.nomeCompleto().invalid()) {
        <p class="identificacao-erro">Campo obrigatório.</p>
      }
    </div>

    <div class="identificacao-linha identificacao-linha-dupla">
      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-cpf">
          CPF <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
        </label>
        <input
          id="identificacao-cpf"
          class="identificacao-input"
          type="text"
          inputmode="numeric"
          placeholder="000.000.000-00"
          [mask]="mascaraCpf"
          [formField]="store.identificacaoForm.cpf"
        />
        @if (store.identificacaoForm.cpf().touched() && store.identificacaoForm.cpf().invalid()) {
          <p class="identificacao-erro">
            {{ store.identificacaoForm.cpf().errors()[0]?.message ?? 'Campo obrigatório.' }}
          </p>
        }
      </div>

      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-telefone">Telefone</label>
        <input
          id="identificacao-telefone"
          class="identificacao-input"
          type="tel"
          inputmode="tel"
          autocomplete="tel"
          placeholder="(71) 00000-0000"
          [mask]="mascaraTelefone"
          [formField]="store.identificacaoForm.telefone"
        />
      </div>
    </div>

    <div class="identificacao-campo">
      <label class="identificacao-rotulo" for="identificacao-email">
        E-mail <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
      </label>
      <input
        id="identificacao-email"
        class="identificacao-input"
        type="email"
        autocomplete="email"
        placeholder="seuemail@exemplo.com"
        [formField]="store.identificacaoForm.email"
      />
      @if (store.identificacaoForm.email().touched() && store.identificacaoForm.email().invalid()) {
        <p class="identificacao-erro">
          {{ store.identificacaoForm.email().errors()[0]?.message ?? 'Campo obrigatório.' }}
        </p>
      }
    </div>

    <div class="identificacao-campo">
      <label class="identificacao-rotulo" for="identificacao-tipo">
        Tipo de solicitante <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
      </label>
      <div class="identificacao-select-caixa">
        <select
          id="identificacao-tipo"
          class="identificacao-input"
          [formField]="store.identificacaoForm.tipoSolicitante"
        >
          <option value="" disabled>Selecione o tipo de solicitante</option>
          @for (tipo of tiposSolicitante; track tipo.chave) {
            <option [value]="tipo.chave">{{ tipo.rotulo }}</option>
          }
        </select>

        <i-lucide class="identificacao-select-seta" name="chevron-down" size="18" aria-hidden="true"></i-lucide>
      </div>
      @if (store.identificacaoForm.tipoSolicitante().touched() && store.identificacaoForm.tipoSolicitante().invalid()) {
        <p class="identificacao-erro">
          {{ store.identificacaoForm.tipoSolicitante().errors()[0]?.message ?? 'Campo obrigatório.' }}
        </p>
      }
    </div>

    <div class="identificacao-campo">
      <label class="identificacao-rotulo" for="identificacao-logradouro">
        Logradouro
        @if (correspondencia()) {
          <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
        }
      </label>
      <input
        id="identificacao-logradouro"
        class="identificacao-input"
        type="text"
        autocomplete="address-line1"
        placeholder="Rua, avenida, travessa…"
        [formField]="store.identificacaoForm.logradouro"
      />
      @if (store.identificacaoForm.logradouro().touched() && store.identificacaoForm.logradouro().invalid()) {
        <p class="identificacao-erro">{{ store.identificacaoForm.logradouro().errors()[0]?.message }}</p>
      }
    </div>

    <div class="identificacao-linha identificacao-linha-dupla">
      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-numero">
          Número
          @if (correspondencia()) {
            <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
          }
        </label>
        <input
          id="identificacao-numero"
          class="identificacao-input"
          type="text"
          placeholder="Ex.: 158 ou S/N"
          [formField]="store.identificacaoForm.numero"
        />
        @if (store.identificacaoForm.numero().touched() && store.identificacaoForm.numero().invalid()) {
          <p class="identificacao-erro">{{ store.identificacaoForm.numero().errors()[0]?.message }}</p>
        }
      </div>

      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-complemento">Complemento</label>
        <input
          id="identificacao-complemento"
          class="identificacao-input"
          type="text"
          autocomplete="address-line2"
          placeholder="Apartamento, bloco…"
          [formField]="store.identificacaoForm.complemento"
        />
      </div>
    </div>

    <div class="identificacao-campo">
      <label class="identificacao-rotulo" for="identificacao-bairro">
        Bairro
        @if (correspondencia()) {
          <span class="identificacao-obrigatorio" aria-hidden="true">*</span>
        }
      </label>
      <input
        id="identificacao-bairro"
        class="identificacao-input"
        type="text"
        placeholder="Digite o bairro"
        [formField]="store.identificacaoForm.bairro"
      />
      @if (store.identificacaoForm.bairro().touched() && store.identificacaoForm.bairro().invalid()) {
        <p class="identificacao-erro">{{ store.identificacaoForm.bairro().errors()[0]?.message }}</p>
      }
    </div>

    <div class="identificacao-linha identificacao-linha-dupla">
      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-cidade">Cidade</label>
        <input
          id="identificacao-cidade"
          class="identificacao-input"
          type="text"
          autocomplete="address-level2"
          placeholder="Salvador"
          [formField]="store.identificacaoForm.cidade"
        />
      </div>

      <div class="identificacao-campo">
        <label class="identificacao-rotulo" for="identificacao-uf">UF</label>
        <div class="identificacao-select-caixa">
          <select id="identificacao-uf" class="identificacao-input" [formField]="store.identificacaoForm.uf">
            <option value="">Selecione</option>
            @for (uf of unidadesFederativas; track uf) {
              <option [value]="uf">{{ uf }}</option>
            }
          </select>

          <i-lucide class="identificacao-select-seta" name="chevron-down" size="18" aria-hidden="true"></i-lucide>
        </div>
      </div>
    </div>

    <div class="identificacao-campo identificacao-campo-curto">
      <label class="identificacao-rotulo" for="identificacao-cep">CEP</label>
      <input
        id="identificacao-cep"
        class="identificacao-input"
        type="text"
        inputmode="numeric"
        autocomplete="postal-code"
        placeholder="40000-000"
        [mask]="mascaraCep"
        [formField]="store.identificacaoForm.cep"
      />
    </div>

    @if (store.anonimo()) {
      <p class="identificacao-alerta" role="note">
        <i-lucide name="triangle-alert" size="18" aria-hidden="true"></i-lucide>
        Se optar por continuar como solicitação anônima, os prazos legais de monitoramento e o envio de
        notificações de e-mail podem não ser garantidos por razões técnicas.
      </p>
    }
  </form>

  <app-cartao-acesso-sic
    [sessaoIniciada]="store.sessaoIniciada()"
    [anonimo]="store.anonimo()"
    [focarLogin]="focarLogin()"
    (autenticado)="autenticado.emit()"
    (acessarGov)="acessarGov.emit()"
    (seguirAnonimo)="seguirAnonimo.emit()"
    (saiu)="saiu.emit()"
  ></app-cartao-acesso-sic>
</div>
